import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { AuthFacade, UserPermission } from '@mitsubishi/core';
import { SectionTitleComponent } from '@mitsubishi/shared/ui';

import { FieldWrapper, FormlyField } from '@ngx-formly/core';

@Component({
  selector: 'apm-gallery-wrapper',
  templateUrl: './gallery-wrapper.component.html',
  styleUrls: ['./gallery-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyField, SectionTitleComponent, MatTooltip],
})
export class GalleryWrapperComponent extends FieldWrapper {
  hasDatasheetMoreDetailsPermission = inject(AuthFacade).hasPermission(UserPermission.DatasheetMoreDetails);
}
